import { Routes } from '@angular/router';

/** Plantation dev utilities — mounted at /tools and /_tools from app.routes (see devToolsGuard). */
export const TOOLS_CHILD_ROUTES: Routes = [
    {
        path: 'bin-to-geojson',
        loadComponent: () =>
            import('./bin-to-geojson/bin-to-geojson/bin-to-geojson.component').then((m) => m.BinToGeojsonComponent),
    },
];
